import { render } from "./homeworkList.vue?vue&type=template&id=86c4a15e&scoped=true"
import script from "./homeworkList.vue?vue&type=script&lang=js"
export * from "./homeworkList.vue?vue&type=script&lang=js"

import "./homeworkList.vue?vue&type=style&index=0&id=86c4a15e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c4a15e"]])

export default __exports__